import platformUtils from '../platformUtils';

function extractModelDataFromSrc(src) {
  const mediaSrcHandler = platformUtils.getMediaSrcHandler();
  const parseMediaItem = mediaSrcHandler.parseMediaSrc(
    src,
    mediaSrcHandler.types.DOCUMENT
  );
  if (parseMediaItem.error) {
    return null;
  }

  return parseMediaItem;
}

export default {
  extractModelDataFromSrc
};
